<form>
  <form-holder>
    <page-header class="text-3xl">Sign Up</page-header>

    <p class="text-warning">
      <fa-icon [icon]="faTriangleExclamation" class="mr-1"></fa-icon>
      Remember to make sure your username matches your PSN/RPCN id!
    </p>

    <form-input [icon]="faUser" name="Username" type="text" [(value)]="username"></form-input>
    <form-input [icon]="faEnvelope" name="Email Address" type="text" [(value)]="email"></form-input>
    <form-input [icon]="faKey" name="Password" type="password" [(value)]="password"></form-input>
    <form-input [icon]="faKey" name="Confirm Password" type="password" [(value)]="confirmPassword"></form-input>

      <p class="text-dangerous">
          Before playing, please note that LBP's online functionality is vulnerable to many security issues.
      </p>

      <p class="text-dangerous font-bold">
          By playing LBP online, you are playing at YOUR OWN RISK. We are not responsible for any damage caused to you or your console.
      </p>

      <a href="https://docs.littlebigrefresh.com/lbp-security" class="hover:underline text-secondary-bright">
          Click here to learn more about LBP security.
      </a>

    <primary-button class="min-w-full" [icon]="faUserPlus" text="Register" (click)="register()"></primary-button>

    <divider class="w-full"></divider>

    <p>Already have an account?</p>
    <secondary-button [icon]="faSignIn" text="Log in" routerLink="/login"></secondary-button>
  </form-holder>
</form>
